/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Λεπτομέρειες μηνύματος',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Σφάλμα',
    FETCH_DATA: 'Λήψη δεδομένων',
    NO_ORDER: 'Κανένα αγροτεμάχιο δεν θα μπορούσε να συνταχθεί'
  },
  HEADER: {
    DATE: 'Ημερομηνία',
    MESSAGE: 'Μήνυμα',
    NAME: 'Όνομα πελάτη',
    ORDER_CODE: 'Κωδικός παραγγελίας',
    ORDER_DATE: 'Ημερομηνία παραγγελίας',
    ORDER_ID: 'Παραγγελία',
    ORDER_VALUE: 'Αξία',
    PAYMENT_DATE: 'Ημερομηνία πληρωμής',
    PAYMENT_STATE: 'Κατάσταση πληρωμής',
    PRICE: 'Τιμή',
    VALUE: 'Αξία'
  },
  LABEL: {
    COPIED: 'Αντιγραφή!',
    EXPORT: 'Εξαγωγή',
    GIVEWAY_DATE: 'Ημερομηνία κλήρωσης:',
    MONTH: 'Μήνας',
    ORDER_PRIZE_MSG: 'Βραβευμένη παραγγελία:',
    PAYED: 'Πληρωμένο',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Απλήρωτη',
    UNTIL: 'a',
    YEAR: 'Έτος'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Δεν υπάρχουν μηνύματα',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION:
      'Δεν υπάρχουν μηνύματα από πελάτες (ακόμα).',
    NO_ROWS_ORDERS: 'Δεν υπάρχουν παραγγελίες',
    NO_ROWS_ORDERS_DESCRIPTION: 'Δεν υπάρχουν παραγγελίες (ακόμη).'
  },
  SUCCESS: {
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    DATE: 'Ημερομηνία',
    ORDER_CODE: 'Κωδικός παραγγελίας',
    ORDER_ID: 'Παραγγελία',
    PAYMENT_DATE: 'Ημερομηνία πληρωμής',
    PAYMENT_STATE: 'Κατάσταση πληρωμής',
    PRICE: 'Τιμή',
    VALUE: 'Αξία'
  }
};
